<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myrequest.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myrequest.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.details') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper mt-30">
        <v-flex class="inner_basic_wrap type2">
          <v-tabs
            class="my_app_tabs_data type2"
            hide-slider
            grow
          >
            <v-tab>{{ $t('myrequest.view.fields.request_data') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.attached_document') }}</v-tab>
            <v-tab v-if="paymentList.length > 0">{{ $t('myrequest.view.fields.invoice_receipt') }}</v-tab>

            <v-tab-item>
              <v-layout class="mt-20">
                <ApplicationInformation
                  :receipt_no.sync = receipt_no
                />
              </v-layout>
              <v-layout class="mt-20">
                <div style="width: 100%">
                  <h2 class="nec_title type3" style="color:#fff;">{{ $t('maintenance.restoration.fields.reason') }}</h2>
                  <v-textarea
                    outlined
                    class="br_none mt-15 text_icon_type type2 ie_textarea login_text_field"
                    width="100%"
                    readonly
                    v-model="notes"
                  >
                  </v-textarea>
                </div>
              </v-layout>

            </v-tab-item>

            <v-tab-item>
              <DocumentViewer
                :items="documentFileList"
              />
            </v-tab-item>

            <v-tab-item>
              <payment
                :payments.sync="paymentList"
                :receipt_no="receipt_no"
                :payment_history_seq="payment_history_seq"
                :query="$route.query"
                paid="Y"
              >
              </payment>
            </v-tab-item>

          </v-tabs>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoList()"
              >{{ $t('common.button.go_to_list') }}</v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import ApplicationInformation from '@/components/layout/ApplicationInformation'
import Payment from '@/components/layout/Payment'

export default {
  components :{
    ApplicationInformation,
    DocumentViewer,
    Payment
  },
  data () {
    return {
      receipt_no : this.$route.params.receipt_no,
      payment_history_seq: null,
      paymentList: [],
      documentFileList: [],
      notes : ''
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetDocumentFileList()
    this.fnGetPaymentList()
    this.fnGetRestoration()
  },
  methods: {
    fnGoList() {
      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push('/myrequest/list?' + qryStr)
    },

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetPaymentList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/payments',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.paymentList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPaymentList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetRestoration(){
      requestApi({
        url: '/receivings/'+ this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.notes = res.data.notes

          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRestoration()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  }
}
</script>